module.exports = __webpack_public_path__ + "media/images/homes/marketing-3319815fe988ad3317b7ad49a498e5c4.svg";